import React from "react";
import { useNavigate } from "react-router-dom";
import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    CardActionArea,
} from "@mui/material";
import {
    Assignment,
    AccountBalance,
    People,
    TwoWheeler,
    Description,
} from "@mui/icons-material";
import { motion } from "framer-motion";
import "./HomePage.css";

const modules = [
    {
        title: "Questionnaire",
        description: "Suivi des données de collecte et gestion des déchets.",
        icon: <Assignment sx={{ fontSize: 50, color: "#1976d2" }} />,
        path: "/questionnaire",
    },
    {
        title: "Bokimbola",
        description: "Suivi financier : entrées, sorties, budget, factures.",
        icon: <AccountBalance sx={{ fontSize: 50, color: "#2e7d32" }} />,
        path: "/bokimbola",
    },
    {
        title: "BokiMpanjifa",
        description: "Gestion des ménages, paiements et suivis hebdomadaires.",
        icon: <People sx={{ fontSize: 50, color: "#6a1b9a" }} />,
        path: "/bokimpanJifa",
    },
    {
        title: "Fiche Tricycle",
        description: "Données de transport : trajets, carburant, kilomètres.",
        icon: <TwoWheeler sx={{ fontSize: 50, color: "#ef6c00" }} />,
        path: "/tricycle",
    },
    {
        title: "Fiche Fanoratana Anarana",
        description: "Inscriptions et visites de suivi des ménages.",
        icon: <Description sx={{ fontSize: 50, color: "#ad1457" }} />,
        path: "/fanoratana",
    },
];

export default function HomePage() {
    const navigate = useNavigate();

    return (
        <Box className="home-root">
            <Typography variant="h4" className="home-title">
                Tableau de bord principal
            </Typography>

            <Grid container spacing={3} justifyContent="center">
                {modules.map((m, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.98 }}
                            transition={{ type: "spring", stiffness: 200 }}
                        >
                            <Card className="home-card">
                                <CardActionArea onClick={() => navigate(m.path)}>
                                    <Box className="home-icon">{m.icon}</Box>
                                    <CardContent>
                                        <Typography
                                            variant="h6"
                                            component="div"
                                            className="home-card-title"
                                        >
                                            {m.title}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {m.description}
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </motion.div>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
